module.exports = __webpack_public_path__ + "web/img/tpsn_status_30.eca6621e.png";